import { apiWithToken } from '../api';

const resouceUrl = '/questao_analises';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {

  return await api.get(`${resouceUrl}`, {
    params: {
      fields:'id,nome',
      raw_list: true
    }
  });
};

export const show = async (id, params) => {

  return await api.get(`${resouceUrl}/${id}`, {
    params: {
      ...params
    }
  });

}

export const update = async (id, meio_analise) => {
  return await api.put(`${resouceUrl}/${id}`, meio_analise);
}


export const store = async (meio_analise) => {
  let response = await api.post(resouceUrl , meio_analise);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}

export const activate = async (id) => {
  return await api.post(`${resouceUrl}/${id}/activate`);
}

export const import_data = async (tipo_meio_analise_id, data_file_csv) => {
  let formData = new FormData();
  formData.append('arquivo', data_file_csv);
  formData.append('tipo_meio_analise_id', tipo_meio_analise_id);

  return await api.post(`${resouceUrl}/import_data`,
    formData,
    tipo_meio_analise_id
    , {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}

